import React, { useEffect, useState } from "react";
import DataTable, { ExpanderComponentProps } from '../../../interfaccia/DataTableBase';
import umanizzaDataSenzaOre from "../../../interfaccia/funzioniComuni/umanizzaDataSenzaOre";

function ListaStoricoOrdini({
    lista,
    loading
}) {

    const [rows, setRows] = useState(
        lista
      )
    
      useEffect(() => {
        setRows(lista)
      }, [lista]);


      

      const colonnaUniversale = function (nomeDato, labelDato, width, sortable, hide, reorder, conditionalCellStyles, ignoreRowClick, sortField, compact) {
        return ({
          selector: row => row[nomeDato],
          name: labelDato,
          sortable: sortable,
          hide: hide,
          reorder: reorder,
          width: width + "px",
          conditionalCellStyles: conditionalCellStyles,
          ignoreRowClick: ignoreRowClick,
          sortField: sortField,
          compact: compact
        })
      }

      const colonnaData = function (nomeDato, labelDato, width, sortField, compact) {
        return ({
          selector: row => row[nomeDato],
          name: labelDato,
          sortable: true,
          sortField: sortField,
          reorder: true,
          width: width + "px",
          compact: {compact},
          format: (row) => {
            if (row[nomeDato] == null) {
              return '';
            }
            return `${umanizzaDataSenzaOre(row[nomeDato])}`;
          }
        }
        )
      }

      const colonnaImporto = function (nomeDato, labelDato, width, sortField) {
        return ({
          selector: row => row[nomeDato],
          name: labelDato,
          sortable: false,
          reorder: false,
          sortField: sortField,
          width: width + "px",
          format: row => {
            if (row[nomeDato] == null) {
              return '';
            }
            const number = parseInt(row[nomeDato])
            const numComma = number.toString().replace(".", ",")
            return `${numComma} €`;
          }
        }
        )
      }

      const columns = [
        //nomeDato, labelDato, width, sortable, hide, reorder, conditionalCellStyles, ignoreRowClick, sortField, compact
        colonnaData("giorno", "Giorno", 100, false, false),
        colonnaUniversale('numeroOrdini_Prato','PN ord.',65,true,"sm",false,false,false,false,true),
        colonnaImporto('importo_Prato', 'PN €', 100, false),
        colonnaUniversale('numeroOrdini_Torino','JS ord.',65,true,"sm",false,false,false,false,true),
        colonnaImporto('importo_Torino', 'JS €', 100, false),
        colonnaUniversale('numeroOrdini_Villanova','VM ord.',65,true,"sm",false,false,false,false,true),
        colonnaImporto('importo_Villanova', 'VM €', 100, false),
        colonnaUniversale('numeroOrdini_totale','TOT ord.',65,true,"sm",false,false,false,false,true),
        colonnaImporto('importo_totale', 'TOT €', 100, false),
      ];
    
      return (
        <div
          className="h-100"
        >
          <DataTable
            data={rows}
            columns={columns}
            fixedHeader={false}
            fixedHeaderScrollHeight={"100px"}
            striped={true}
            progressPending={loading}
            noDataComponent={<h3 className='ma5 pa5'>Nessun ordine risponde alla tua ricerca.</h3>}
            progressComponent={<h3 className='ma5 pa5 '>carico i dati...</h3>}
            pagination
            paginationRowsPerPageOptions={[10,50,200]}
            paginationPerPage={10}
            paginationComponentOptions={{ rowsPerPageText: '', rangeSeparatorText: 'di', noRowsPerPage: false, selectAllRowsItem: false, selectAllRowsItemText: 'Seleziona tutti' }}
          />
          
        </div>
      )

}

export default ListaStoricoOrdini;